export default () => ({
    sortKey: 'archiveYear',
    sortIsDesc: true,

    sort() {
        const items = [...this.$refs.grid.children]

        items.sort((a, b) => {
            const aValue = a.children[0].dataset[this.sortKey] || ''
            const bValue = b.children[0].dataset[this.sortKey] || ''

            if (this.sortIsDesc) {
                return bValue.localeCompare(aValue)
            }

            return aValue.localeCompare(bValue)
        })

        this.$refs.grid.innerHTML = ''
        items.forEach((child) => this.$refs.grid.appendChild(child))
    },

    sortBy(key, isDesc) {
        this.sortKey = key
        this.sortIsDesc = isDesc

        this.sort()
    },
})
